function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import draggable from 'vuedraggable';
import i18n from '@/utils/i18n';
import axios from 'axios';
import SvgIcon from '@/components/svg-icon-nc';
import { ext_charts_widgets, dashboard_container_schema } from '../charts-schema.js';
import { ext_chart_containers as EC_CONS, ext_charts_widgets as EC_WS } from '../charts-schema.js';
import { generateId, addWindowResizeHandler } from '@/utils/util';
import { containers, advancedFields, basicFields, customFields } from '@/components/form-designer/widget-panel/widgetsConfig.js';
var Ze = Object.defineProperty,
  Ge = Object.defineProperties;
var Xe = Object.getOwnPropertyDescriptors;
var Qe = Object.getOwnPropertySymbols;
var Ke = Object.prototype.hasOwnProperty,
  Je = Object.prototype.propertyIsEnumerable;
var ze = function ze(o, e, n) {
    return e in o ? Ze(o, e, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: n
    }) : o[e] = n;
  },
  Ie = function Ie(o, e) {
    for (var n in e || (e = {})) Ke.call(e, n) && ze(o, n, e[n]);
    if (Qe) {
      var _iterator = _createForOfIteratorHelper(Qe(e)),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var n = _step.value;
          Je.call(e, n) && ze(o, n, e[n]);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    return o;
  },
  We = function We(o, e) {
    return Ge(o, Xe(e));
  };
var je = function je(o, e, n) {
  return ze(o, _typeof(e) != 'symbol' ? e + '' : e, n), n;
};
export default {
  name: 'FieldPanel',
  mixins: [i18n],
  components: {
    SvgIcon: SvgIcon,
    draggable: draggable
  },
  props: {
    designer: Object
  },
  inject: ['getBannedWidgets', 'getDesignerConfig'],
  data: function data() {
    return {
      chartContainers: ext_charts_widgets,
      designerConfig: this.getDesignerConfig(),
      firstTab: 'componentLib',
      activeNames: ['1', '2', '3', '4'],
      metadataActiveNames: ['0', '1', '2', '3', '4'],
      containers: [],
      commonContainers: [],
      basicFields: [],
      advancedFields: [],
      customFields: [],
      chartWidgets: [],
      metaFields: {
        main: {
          entityName: '',
          entityLabel: '',
          fieldList: [{
            type: '',
            icon: '',
            displayName: '',
            options: {}
          }]
        },
        detail: [{
          entityName: '',
          entityLabel: '',
          fieldList: [{
            type: '',
            icon: '',
            displayName: '',
            options: {}
          }]
        }]
      },
      ftcKey: 'ftc' + generateId(),
      scrollerHeight: 0
    };
  },
  computed: {
    showComponentLib: function showComponentLib() {
      return this.designerConfig.componentLib === void 0 ? !0 : !!this.designerConfig.componentLib;
    },
    showFormTemplates: function showFormTemplates() {
      return this.designerConfig.formTemplates === void 0 ? !0 : !!this.designerConfig.formTemplates;
    },
    showChartLib: function showChartLib() {
      return this.designerConfig.chartLib === void 0 ? !1 : !!this.designerConfig.chartLib;
    },
    showMetadataLib: function showMetadataLib() {
      return this.designerConfig.metadataLib === void 0 ? !1 : !!this.designerConfig.metadataLib;
    }
  },
  created: function created() {
    var _this = this;
    this.designerConfig.chartLib && (this.firstTab = 'chartLib'), this.designerConfig.metadataLib && (this.firstTab = 'metadataLib'), this.loadWidgets(), this.designer.handleEvent('refresh-form-templates', function () {
      _this.ftcKey = 'ftc' + generateId();
    });
    EC_CONS.forEach(function (con) {
      _this.designer.addChartContainerSchema(con);
    });
    EC_WS.forEach(function (wgt) {
      _this.designer.addChartSchema(wgt);
    });
  },
  mounted: function mounted() {
    var _this2 = this;
    this.scrollerHeight = window.innerHeight - 54 + 'px';
    addWindowResizeHandler(function () {
      _this2.$nextTick(function () {
        _this2.scrollerHeight = window.innerHeight - 54 + 'px';
      });
    });
  },
  methods: {
    getMetaFieldLabel: function getMetaFieldLabel(o) {
      var e = o.displayName;
      return e.substring(e.indexOf('.') + 1, e.length);
    },
    getWidgetLabel: function getWidgetLabel(o) {
      return this.i18nt("extension.widgetLabel.".concat(o.type));
    },
    isBanned: function isBanned(o) {
      return this.getBannedWidgets().indexOf(o) > -1;
    },
    getFTTitle: function getFTTitle(o) {
      var e = getLocale();
      return !!o.i18n && !!o.i18n[e] && o.i18n[e].title || o.title;
    },
    loadWidgets: function loadWidgets() {
      var _this3 = this;
      ;
      this.containers = containers.map(function (o) {
        return We(Ie({
          key: generateId()
        }, o), {
          displayName: _this3.i18nt("designer.widgetLabel.".concat(o.type), "extension.widgetLabel.".concat(o.type))
        });
      }).filter(function (o) {
        return !o.internal && !_this3.isBanned(o.type);
      }), this.commonContainers = this.containers.filter(function (o) {
        return !!o.commonFlag;
      }), this.basicFields = basicFields.map(function (o) {
        return We(Ie({
          key: generateId()
        }, o), {
          displayName: _this3.i18nt("designer.widgetLabel.".concat(o.type), "extension.widgetLabel.".concat(o.type))
        });
      }).filter(function (o) {
        return !_this3.isBanned(o.type);
      }), this.advancedFields = advancedFields.map(function (o) {
        return We(Ie({
          key: generateId()
        }, o), {
          displayName: _this3.i18nt("designer.widgetLabel.".concat(o.type), "extension.widgetLabel.".concat(o.type))
        });
      }).filter(function (o) {
        return !_this3.isBanned(o.type);
      }), this.customFields = customFields.map(function (o) {
        return We(Ie({
          key: generateId()
        }, o), {
          displayName: _this3.i18nt("designer.widgetLabel.".concat(o.type), "extension.widgetLabel.".concat(o.type))
        });
      }).filter(function (o) {
        return !_this3.isBanned(o.type);
      }), this.chartContainers = this.designer.chartContainers.map(function (o) {
        return We(Ie({
          key: generateId()
        }, o), {
          displayName: _this3.i18nt("designer.widgetLabel.".concat(o.type), "extension.widgetLabel.".concat(o.type))
        });
      }).filter(function (o) {
        return !o.internal && !_this3.isBanned(o.type);
      }), this.chartWidgets = this.designer.chartWidgets.map(function (o) {
        return We(Ie({
          key: generateId()
        }, o), {
          displayName: _this3.i18nt("designer.widgetLabel.".concat(o.type), "extension.widgetLabel.".concat(o.type))
        });
      }).filter(function (o) {
        return !_this3.isBanned(o.type);
      });
    },
    handleContainerWidgetClone: function handleContainerWidgetClone(o) {
      return this.designer.copyNewContainerWidget(o);
    },
    handleFieldWidgetClone: function handleFieldWidgetClone(o) {
      return this.designer.copyNewFieldWidget(o);
    },
    checkContainerMove: function checkContainerMove(o) {
      return this.designer.checkWidgetMove(o);
    },
    checkFieldMove: function checkFieldMove(o) {
      return this.designer.checkFieldMove(o);
    },
    onContainerDragEnd: function onContainerDragEnd(o) {},
    addContainerByDbClick: function addContainerByDbClick(o) {
      this.designer.addContainerByDbClick(o);
    },
    addFieldByDbClick: function addFieldByDbClick(o) {
      this.designer.addFieldByDbClick(o);
    },
    addChartContainerByDbClick: function addChartContainerByDbClick(o) {
      this.designer.addChartContainerByDbClick(o);
    },
    addChartByDbClick: function addChartByDbClick(o) {
      this.designer.addChartByDbClick(o);
    },
    loadFormTemplate: function loadFormTemplate(o, e) {
      var _this4 = this;
      this.$confirm(this.i18nt('designer.hint.loadFormTemplateHint'), this.i18nt('render.hint.prompt'), {
        confirmButtonText: this.i18nt('render.hint.confirm'),
        cancelButtonText: this.i18nt('render.hint.cancel')
      }).then(function () {
        if (e) {
          _this4.designer.loadFormJson(JSON.parse(e)), _this4.$message.success(_this4.i18nt('designer.hint.loadFormTemplateSuccess'));
          return;
        }
        axios.get(o).then(function (n) {
          var l = !1;
          typeof n.data == 'string' ? l = _this4.designer.loadFormJson(JSON.parse(n.data)) : n.data.constructor === Object && (l = _this4.designer.loadFormJson(n.data)), l && _this4.designer.emitHistoryChange(), _this4.$message.success(_this4.i18nt('designer.hint.loadFormTemplateSuccess'));
        }).catch(function (n) {
          _this4.$message.error(_this4.i18nt('designer.hint.loadFormTemplateFailed') + ':' + n);
        });
      }).catch(function (n) {
        console.error(n);
      });
    },
    setMetaFields: function setMetaFields(o) {
      this.metaFields = o;
    }
  }
};